export async function withMinimumDuration<T>(promise: Promise<T>, minimumMs: number): Promise<T> {
  const [result] = await Promise.all([
    promise,
    new Promise((resolve) => setTimeout(resolve, minimumMs))
  ])
  return result
}
